import { TextField, Theme, WithStyles } from "@material-ui/core";
import { bindActions, mockTheme } from "../utils/utils";
import * as React from "react";
import { ComponentClass } from "react";
import { CompanyActions, CompanyState } from "../store/company";
import AsyncTable, { ColumnDefinition } from "../components/AsyncTable";
import { IStore } from "../store";
import { connect } from "react-redux";
import { JSONSchema6 } from "json-schema";
import EnhancedSchemaForm from "../components/schemaForm";
import { ISubmitEvent, UiSchema } from "react-jsonschema-form";

// material
import Grid from "@material-ui/core/Grid";
import { SortDirection } from "@material-ui/core/TableCell";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { Company } from "src/api/model";
import red from "@material-ui/core/colors/red";
import green from "@material-ui/core/colors/green";
import blue from "@material-ui/core/colors/blue";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityOnIcon from "@material-ui/icons/Visibility";
import DeliveryPriceIcon from "@material-ui/icons/MonetizationOn";

// images
import companyImg from "../assets/imgs/company_default.png";

const styles = (theme: Theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: `calc(50% - ${theme.spacing.unit * 3}px)`,
  },
  menu: {
    width: 200,
  },

  routeSelector: {
    width: "100%",
    height: "100%",
  },
  buttons: {
    marginLeft: "auto",
  },
  abm: {
    padding: theme.spacing.unit * 3,
    margin: theme.spacing.unit,
  },
  disableIcon: {
    color: red[900],
  },
  enableIcon: {
    color: green[900],
  },
  editIcon: {
    color: blue[500],
  },
  imageColumn: {
    width: "50px",
    padding: "5px",
    textAlign: "center",
  },
});

const classesType = styles(mockTheme);

interface CompanyProps extends WithStyles<keyof typeof classesType> {
  actions: CompanyActions;
  data: CompanyState;
}

interface CompanysState {
  abm: {
    id?: number;
    name: string;
    photo: string;
    state: string;
    priceDelivery: number;
  };
  open: boolean;
  openPrice: boolean;
  table: {
    data: any;
    sortBy: string;
    sortDirection: SortDirection;
    columnData: ColumnDefinition[];
  };
}

const schema: JSONSchema6 = {
  definitions: {
    company: {
      type: "object",
      // required: ["name", "photo"],
      required: ["name"],
      properties: {
        name: { type: "string", title: "Nombre" },
        // photo: { type: "string", title: "Foto" },
      },
    },
    admin: {
      type: "object",
      required: ["username", "pass", "email"],
      properties: {
        name: { type: "string", title: "Username" },
        pass: { type: "string", title: "Password", format: "password" },
        email: { type: "string", title: "Email" },
      },
    },
  },

  title: "",
  type: "object",
  required: ["company", "admin"],
  properties: {
    company: { title: "Empresa", $ref: "#/definitions/company" },
    admin: { title: "Administrador", $ref: "#/definitions/admin" },
  },
};

const uiSchema: UiSchema = {
  blendMode: {
    "ui:enumDisabled": ["multiply"],
  },
};

class CompanyPage extends React.Component<CompanyProps, CompanysState> {
  constructor(props: CompanyProps) {
    super(props);

    this.state = {
      abm: {
        id: 0,
        name: "",
        photo: "",
        priceDelivery: 0,
        state: "ACTIVE",
      },
      open: false,
      openPrice: false,
      table: {
        data: [],
        sortBy: "name",
        sortDirection: "desc",
        columnData: [
          {
            path: "foto",
            label: "Foto",
            draw: (cd: ColumnDefinition, data: Company) => {
              return (
                <div>
                  <Tooltip title={"Foto"}>
                    <img
                      src={data.photo ? data.photo : companyImg}
                      className={this.props.classes.imageColumn}
                    />
                  </Tooltip>
                </div>
              );
            },
          },
          {
            path: "name",
            numeric: false,
            disablePadding: true,
            label: "Nombre",
          },

          { path: "state", numeric: false, label: "Estado" },
          {
            path: "",
            numeric: false,
            label: "Acciones",
            draw: (cd: ColumnDefinition, data: Company) => {
              return (
                <div>
                  <IconButton
                    className={
                      data.state === "ACTIVE"
                        ? this.props.classes.enableIcon
                        : this.props.classes.disableIcon
                    }
                  >
                    {data.state === "ACTIVE" ? (
                      <Tooltip title="Activo">
                        <VisibilityOnIcon />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Inactivo">
                        <VisibilityOffIcon />
                      </Tooltip>
                    )}
                  </IconButton>
                  <IconButton
                    className={this.props.classes.editIcon}
                    aria-label="Precio del delivery"
                    onClick={this.configPriceDelivery(data)}
                  >
                    <Tooltip title="Precio del delivery">
                      <DeliveryPriceIcon />
                    </Tooltip>
                  </IconButton>
                </div>
              );
            },
          },
        ],
      },
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
    this.changePrice = this.changePrice.bind(this);
    this.savePrice = this.savePrice.bind(this);
  }

  handleSubmit(e: ISubmitEvent<any>) {
    console.log("formData", e.formData);

    this.props.actions.save(e.formData.company, e.formData.admin);
    this.hideDialog();
  }

  sort(name: string) {
    return () => {
      this.setState({
        ...this.state,
        table: {
          ...this.state.table,
          sortBy: name,
          sortDirection: "desc",
        },
      });
    };
  }

  configPriceDelivery(data: Company) {
    return (event: React.MouseEvent<HTMLElement>) => {
      console.log("Data de empresa: ", data);

      this.setState({
        abm: {
          ...data,
        },
        open: false,
        openPrice: true,
      });
    };
  }

  hideDialog() {
    this.setState({
      abm: {
        ...this.state.abm,
      },
      open: false,
      openPrice: false,
    });
  }

  showDialog() {
    this.setState({
      abm: {
        name: "",
        photo: "",
        state: "ACTIVE",
        priceDelivery: 0,
      },
      open: true,
    });
  }

  changePrice(e: any) {
    this.setState({
      abm: {
        ...this.state.abm,
        priceDelivery: Number(e),
      },
    });
  }

  savePrice() {
    this.props.actions.save({ ...this.state.abm });
    this.hideDialog();
  }

  componentDidMount() {
    this.props.actions.fetch();
  }

  render() {
    return (
      <Grid container spacing={24}>
        <Grid item sm={12} md={12} lg={12}>
          <AsyncTable
            columnDefinition={this.state.table.columnData}
            title="Empresas"
            data={this.props.data.data}
            defaultOrder={{
              name: "name",
              direction: "desc",
            }}
            headerButtons={
              <Tooltip title="Agregar">
                <IconButton aria-label="Agregar" onClick={this.showDialog}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            }
          />
        </Grid>
        {
          <Dialog open={this.state.open} maxWidth="md" fullWidth={true}>
            <Paper className={this.props.classes.abm}>
              <EnhancedSchemaForm
                schema={schema}
                onSubmit={this.handleSubmit}
                uiSchema={uiSchema}
              >
                <div>
                  <Button variant="contained" onClick={this.hideDialog}>
                    Cancelar
                  </Button>
                  <Button variant="contained" color="primary" type="submit">
                    Aceptar
                  </Button>
                </div>
              </EnhancedSchemaForm>
            </Paper>
          </Dialog>
        }
        <Dialog open={this.state.openPrice} maxWidth="sm" fullWidth={true}>
          <Paper className={this.props.classes.abm}>
            <div style={{ padding: 10 }}>
              <h6>Costo de delivery: </h6>
              <TextField
                id="price"
                label="Precio por km"
                type="number"
                value={this.state.abm.priceDelivery || ""}
                onChange={(e) => this.changePrice(e.target.value)}
                style={{
                  width: "100%",
                }}
                margin="normal"
                placeholder="Ingrese un precio por km"
              />
            </div>
            <div>
              <Button variant="contained" onClick={this.hideDialog}>
                Cancelar
              </Button>
              &nbsp;
              <Button
                variant="contained"
                color="primary"
                onClick={this.savePrice}
              >
                Aceptar
              </Button>
            </div>
          </Paper>
        </Dialog>
      </Grid>
    );
  }
}

const mapStateToProps = (state: IStore, ownProps: any) => ({
  ...ownProps,
  data: state.company,
});

const styled = withStyles(styles as any)(CompanyPage);
const connected = connect(mapStateToProps, bindActions(CompanyActions))(styled);

export default connected as ComponentClass<Partial<CompanyActions>>;



// WEBPACK FOOTER //
// ./src/pages/CompanyPage.tsx